const expertsSwiper = new Swiper(".heth-experts__swiper", {
  loop: true,
      slidesPerView: "auto",

  spaceBetween: 16,
  speed: 600,
  grabCursor: true,
  navigation: {
    prevEl: ".heth-experts__arrow--prev",
    nextEl: ".heth-experts__arrow--next",
  },
  breakpoints: {
  
    575: {
      slidesPerView: 2,
    },
    1023: {
      slidesPerView: 3,
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
  },
});

// Reviews slider
const reviewsSwiper = new Swiper(".heth-reviews__swiper", {
  loop: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 600,
  grabCursor: true,
  navigation: {
    prevEl: ".heth-reviews__btn--prev",
    nextEl: ".heth-reviews__btn--next",
  },
});

$(function () {
  /* ---- FAQ Accordion ---- */
  $(".heth-faq__trigger").on("click", function () {
    let $item = $(this).closest(".heth-faq__item");
    let isOpen = $item.hasClass("is-open");

    // Close all
    $(".heth-faq__item").removeClass("is-open");
    $(".heth-faq__trigger").attr("aria-expanded", "false");

    // Open clicked if it was closed
    if (!isOpen) {
      $item.addClass("is-open");
      $(this).attr("aria-expanded", "true");
    }
  });

  /* ---- Mobile Drawer Menu ---- */
  const $drawer = $("#mobileDrawer");
  const $body = $("body");

  $(".heth-mobile-menu").on("click", function () {
    $drawer.addClass("heth-drawer--open");
    $body.addClass("heth-no-scroll");
  });

  $(".heth-drawer__close, .heth-drawer__overlay, .heth-drawer__link").on("click", function () {
    $drawer.removeClass("heth-drawer--open");
    $body.removeClass("heth-no-scroll");
  });

  // Floating animation for capsule
  function rand(min, max) {
    return (Math.random() * (max - min) + min).toFixed(2);
  }

  $('.heth-capsule').each(function () {
    $(this).css({
      '--dy':     '-' + rand(15, 35) + 'px',
      '--dx':     rand(-25, 25) + 'px',
      '--r':      rand(-15, 15) + 'deg',
      '--dur-y':  rand(5, 9) + 's',
      '--dur-x':  rand(4, 7) + 's',   // different from Y = no sync = organic feel
      '--dur-r':  rand(5, 8) + 's',
      '--delay-y': '-' + rand(0, 5) + 's',
      '--delay-x': '-' + rand(0, 7) + 's',
      '--delay-r': '-' + rand(0, 8) + 's',
    });
  });

  /* ---- Chart Scroll Animation ---- */
  const $chartCard = $('.heth-chart-card, .heth-nad__chart');
  const progressLine = document.getElementById('heth-chart-line-colored');
  const chartSvg = progressLine ? progressLine.ownerSVGElement : null;
  const dots = chartSvg ? Array.from(chartSvg.querySelectorAll('circle')) : [];

  // Sort dots by cx (left to right)
  dots.sort((a, b) => parseFloat(a.getAttribute('cx')) - parseFloat(b.getAttribute('cx')));

  if (progressLine) {
    const pathLength = progressLine.getTotalLength();
    progressLine.style.strokeDasharray = pathLength;
    progressLine.style.strokeDashoffset = pathLength;
  }

  function updateChartAnimation() {
    if (!$chartCard.length || !progressLine) return;

    const rect = $chartCard[0].getBoundingClientRect();
    const viewHeight = window.innerHeight;

    // Start drawing when the card center is at 90% of viewport, finish at 35%
    const cardCenter = rect.top + rect.height / 2;
    const startThreshold = viewHeight * 1.1;
    const endThreshold = viewHeight * 0.35;

    let progress = (startThreshold - cardCenter) / (startThreshold - endThreshold);
    progress = Math.max(0, Math.min(1, progress));

    const pathLength = progressLine.getTotalLength();
    const offset = pathLength - (progress * pathLength);
    progressLine.style.strokeDashoffset = offset;

    // Find the X coordinate of the tip of the drawn line
    let tipX = 0;
    if (progress > 0) {
      const point = progressLine.getPointAtLength(progress * pathLength);
      tipX = point.x;
    }

    // Color the dots when the line reaches them
    const activeColor = chartSvg.dataset.activeColor || '#C1DD29';
    const inactiveColor = chartSvg.dataset.inactiveColor || '#C5D0C9';
    dots.forEach((dot, index) => {
      const cx = parseFloat(dot.getAttribute('cx'));
      if (progress > 0 && cx <= tipX + 3) { // 3px tolerance for a cleaner overlap
        dot.setAttribute('fill', activeColor);
      } else {
        // Ensure first dot gets colored at the very beginning of the animation
        if (index === 0 && progress > 0.005) {
          dot.setAttribute('fill', activeColor);
        } else {
          dot.setAttribute('fill', inactiveColor);
        }
      }
    });
  }

  // Bind events
  $(window).on('scroll resize', updateChartAnimation);

  // Initialize and run once immediately, with a short delay to ensure SVG is layout-ready
  setTimeout(updateChartAnimation, 100);

  /* ---- Responsive Image Optimizer ---- */
  function updateResponsiveImages() {
    const isMobile = window.matchMedia('(max-width: 575px)').matches;
    
    // Optimize <img> tags
    $('img[data-src-desktop][data-src-mobile]').each(function() {
      const $img = $(this);
      const newSrc = isMobile ? $img.data('src-mobile') : $img.data('src-desktop');
      if (newSrc && $img.attr('src') !== newSrc) {
        $img.attr('src', newSrc);
      }
    });

    // Optimize background images
    // $('.responsive-bg[data-bg-desktop][data-bg-mobile]').each(function() {
    //   const $el = $(this);
    //   const newBg = isMobile ? $el.data('bg-mobile') : $el.data('bg-desktop');
    //   const currentBg = $el.css('background-image');
    //   if (newBg && currentBg.indexOf(newBg) === -1) {
    //     $el.css('background-image', `url("${newBg}")`);
    //   }
    // });
  }

  updateResponsiveImages();

  let resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateResponsiveImages, 150);
  });

  /* ---- Simple Script for Product Gallery ---- */
  const $mainImage = $("#hethMainImage");
  const $thumbs = $(".heth-gallery-thumb img");
  const $prevBtn = $(".heth-gallery-prev");
  const $nextBtn = $(".heth-gallery-next");

  if ($mainImage.length > 0 && $thumbs.length > 0) {
    let currentIndex = 0;

    function updateButtons() {
      $prevBtn.prop('disabled', currentIndex === 0);
      $nextBtn.prop('disabled', currentIndex === $thumbs.length - 1);
      $prevBtn.toggleClass('disabled', currentIndex === 0);
      $nextBtn.toggleClass('disabled', currentIndex === $thumbs.length - 1);
    }

    function updateMainImage(index) {
      if (index < 0 || index >= $thumbs.length) return;
      if (currentIndex === index) return;

      // Premium crossfade: Set the wrapper's background to the current image
      const $wrapper = $mainImage.parent();
      $wrapper.css({
        "background-image": `url(${$mainImage.attr("src")})`,
        "background-size": "cover",
        "background-position": "center",
        "border-radius": "16px"
      });

      currentIndex = index;
      updateButtons();

      // Hide the img tag immediately so it reveals the background copy
      $mainImage.css({
        "transition": "none",
        "opacity": 0
      });

      // Swap src and fade in once loaded
      setTimeout(() => {
        $mainImage.attr("src", $thumbs.eq(currentIndex).attr("src"));
        $mainImage.one("load", function() {
          $mainImage.css({
            "transition": "opacity 0.4s ease-in-out",
            "opacity": 1
          });
        });
      }, 50);
    }

    // Initialize buttons state on load
    updateButtons();

    // Thumb clicks
    $(".heth-gallery-thumb").on("click", function() {
      const index = $(this).index();
      updateMainImage(index);
    });

    // Arrow clicks
    $prevBtn.on("click", function() {
      updateMainImage(currentIndex - 1);
    });

    $nextBtn.on("click", function() {
      updateMainImage(currentIndex + 1);
    });
  }

  /* ---- Synergistic Stack Tabs ---- */
  const $stackTabs = $('.heth-stack__tab');
  const $stackItems = $('.heth-stack__item');
  
  if ($stackTabs.length > 0 && $stackItems.length > 0) {
    // Initial setup: clear all active classes
    $stackItems.removeClass('active');
    $stackTabs.removeClass('active');
    
    // Active first tab
    $stackTabs.first().addClass('active');
    $stackItems.first().addClass('active');

    // Bind click for both mobile and desktop
    $stackTabs.on('click', function() {
      if ($(this).hasClass('active')) return;

      const target = $(this).data('target');
      const $targetItem = $(target);

      // Update tabs
      $stackTabs.removeClass('active');
      $(this).addClass('active');
      
      // Update content using only CSS classes
      $stackItems.removeClass('active');
      $targetItem.addClass('active');

      // On mobile, scroll the active tab button into view within the horizontal scroll area
      if (window.innerWidth <= 991) {
        const $sidebar = $('.heth-stack__sidebar');
        const scrollLeft = $(this).position().left + $sidebar.scrollLeft() - ($sidebar.width() / 2) + ($(this).width() / 2);
        $sidebar.animate({ scrollLeft: scrollLeft }, 300);
      }
    });
  }
});
